module.exports = __webpack_public_path__ + "media/rbs_vid_yolo.b87f6249.mp4";